import { render, staticRenderFns } from "./resCar-add.vue?vue&type=template&id=590fcc22&scoped=true&"
import script from "./resCar-add.vue?vue&type=script&lang=js&"
export * from "./resCar-add.vue?vue&type=script&lang=js&"
import style0 from "./resCar-add.vue?vue&type=style&index=0&id=590fcc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fcc22",
  null
  
)

export default component.exports